import { useQuery } from "@tanstack/react-query"
import { EnderecoService } from "../../../../../Services/EnderecoService";
import Select from "antd/lib/select";
import { SelectComPesquisa } from "../../../../SelectComPesquisa";

interface IEstadoSelect extends Omit<React.ComponentProps<typeof Select>, | "showSearch" | "optionFilterProp" | "filterOption"> {

}

export default function EstadoSelect({
    placeholder,
    ...rest
}: IEstadoSelect) {
    const enderecoService = new EnderecoService();

    const {
        isLoading,
        isError,
        data
    } = useQuery({
        queryKey: ["listarEstados"],
        queryFn: () => enderecoService.listarEstados()
    });

    return <SelectComPesquisa
        {...rest}
        loading={isLoading}
        disabled={isError}
        options={data?.data.map((item) => ({
            value: item.codigo,
            label: item.nome,
            sigla: item.sigla
        }))}
        placeholder={placeholder ?? "Selecione"}
    />
}